export const linkSegmentClasses =
    'text-aos-text-link no-underline hover:text-aos-text-link-hover active:text-aos-text-link-pressed'
